import isEmpty from 'lodash/isEmpty';
import {
  getFiltersPayloadSeo,
  getFiltersPayload,
  getPlpUrlQueryValuesSeo,
  getPlpUrlQueryValues,
} from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.utils';
import { getHplpUrlQueryValues } from '../../HorizontalCategory/container/HorizontalCategory.utils';

export const getParams = (
  pathName,
  formDetails,
  isFacetedNavigationEnabled,
  isHPLP,
  seoFacetedNavigationConfig,
  cleanUrlObj
) => {
  if (isFacetedNavigationEnabled && !isHPLP) {
    return getFiltersPayloadSeo(
      pathName,
      formDetails,
      isFacetedNavigationEnabled,
      seoFacetedNavigationConfig,
      cleanUrlObj
    );
  }
  return getFiltersPayload(pathName, formDetails);
};

export const getUpdatedUrl = (
  isHPLP,
  filtersFromUrl,
  asPath,
  isFacetedNavigationEnabled,
  seoFacetedNavigationConfig,
  cleanUrlObj
) => {
  if (isHPLP) {
    return getHplpUrlQueryValues(filtersFromUrl, asPath, true);
  }
  if (isFacetedNavigationEnabled) {
    return getPlpUrlQueryValuesSeo(
      filtersFromUrl,
      asPath,
      true,
      1,
      seoFacetedNavigationConfig,
      cleanUrlObj
    );
  }
  return getPlpUrlQueryValues(filtersFromUrl, asPath, true, 1);
};

export const mergeFilterValues = (selectedFilters, otherFilterValues) => {
  if (!isEmpty(otherFilterValues)) {
    return { ...selectedFilters, ...otherFilterValues };
  }
  return selectedFilters;
};

export const getSelectedFilters = (filters, filterNames) => {
  let selectedFilters = {};
  filterNames.forEach((name) => {
    const key = name[0];
    const filterData = filters[key] || [];

    // find all the selected items from filters list and map it with filter key present in filterNames
    const selectedFiltersData = filterData.filter((item) => item.isSelected).map((item) => item.id);
    const result = {};
    result[key] = selectedFiltersData;
    selectedFilters = mergeFilterValues(selectedFilters, result);
  });
  return selectedFilters;
};
